module.exports = __webpack_public_path__ + "static/media/email-illustration.295c5614.svg";